import React from 'react';
import { SaveState } from '../types';

interface ProgressBarProps {
  progress: number;
  state: SaveState;
  showPercentage?: boolean;
}

export function ProgressBar({ progress, state, showPercentage = true }: ProgressBarProps) {
  const getProgressColor = () => {
    switch (state) {
      case 'saving':
        return 'bg-yellow-400';
      case 'error':
        return 'bg-red-500';
      case 'success':
        return 'bg-emerald-500';
      default:
        return 'bg-emerald-500';
    }
  };

  return (
    <div className="space-y-2">
      {showPercentage && (
        <div className="flex justify-between text-xs text-gray-400 px-1">
          <span>Progresso</span>
          <span>{progress}%</span>
        </div>
      )}
      <div className="bg-navy-700 rounded-full h-2 overflow-hidden">
        <div 
          className={`h-full transition-all duration-200 ease-out ${getProgressColor()}`}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}